import { Notifier } from '../../services/util/PubSub';

export class ProjectStore extends Notifier {
  notifySubscribers() {
    this.publish();
  }
}


// WEBPACK FOOTER //
// ./src/stores/project/ProjectStore.ts